import React from 'react'

import { Box } from '@chakra-ui/react'
import { ItListItem } from 'types/graphql'

import { useWatch } from '@redwoodjs/forms'

import EditItemImage from 'src/components/widgets/EditItemImage/EditItemImage'
import Input from 'src/components/widgets/Input/Input'
import TextArea from 'src/components/widgets/TextArea/TextArea'
import VoiceTipRecorder from 'src/components/widgets/VoiceTipRecorder/VoiceTipRecorder'
import {
  MAX_XL_INPUT_NO_COUNTER,
  MAX_XL_INPUT,
  MAX_LG_INPUT,
  MAX_LG_INPUT_NO_COUNTER,
} from 'src/lib/constants'

import { TypeBuilderProps } from '../..'

const Builder: React.FC<TypeBuilderProps> = ({
  voiceTipRecorderProps,
  itemId,
}) => {
  const item = useWatch<ItListItem>() as ItListItem
  return (
    <Box mt={4} w="full">
      <EditItemImage
        name="image.coverUrl"
        assetId={itemId}
        assetType="itListItemCover"
        borderRadius={12}
        width={1120}
        height={630}
        skipCrop={true}
        hint="600px minimum width suggested."
      />
      {!!item.image?.coverUrl && (
        <>
          <Input
            mt={6}
            clearable
            w="full"
            name="title"
            placeholder="Title"
            data-testid="imageBuilder-title"
            hint="Optional"
            withCounter={true}
            maxLength={MAX_LG_INPUT}
            hideCounterMax={MAX_LG_INPUT_NO_COUNTER}
          />
          <TextArea
            mt={6}
            w="full"
            name="image.description"
            placeholder="Caption"
            data-testid="imageBuilder-description"
            hint="Optional"
            autoExpand
            resize="none"
            rows={1}
            withCounter={true}
            maxLength={MAX_XL_INPUT}
            hideCounterMax={MAX_XL_INPUT_NO_COUNTER}
          />
          <VoiceTipRecorder
            name="hasVoiceTip"
            mt={6}
            title="Voice Tip"
            subtitle="Optional"
            showProfileImage={true}
            {...voiceTipRecorderProps}
          />
        </>
      )}
    </Box>
  )
}

export default Builder
